const DEFAULT_FILE_NAME = 'documento'

export function getFileBaseName(fileUrl?: string | null): string {
    if (!fileUrl) return DEFAULT_FILE_NAME

    const segments = fileUrl.split(/[\\/]/)
    const baseName = segments[segments.length - 1]?.trim()

    return baseName || DEFAULT_FILE_NAME
}
